















import Vue from 'vue'

export default Vue.extend({
  name: 'FavoriteButton',
  props: {
    isFavorited: {
      type: Boolean,
      default: false,
    },
    type: {
      type: String as () => 'icon' | 'button',
      default: 'button',
    },
  },
  methods: {
    handleClick(value: boolean) {
      this.$emit('click', value)
    },
  },
})
